import React from "react";
import "./GigStatsCard.css";

const GigStatsCard = ({ 
    totalGigs = 0, 
    sentUpcoming = 0, 
    completed = 0,
    isLoading = false 
}) => {
    return (
        <div className="gig-stats-card">
            <div className="gig-stats-header">
                <div className="gig-stats-icon">
                    <i className="fa fa-calendar-check"></i>
                </div>
                <div className="gig-stats-title">Gig Stats</div>
            </div>
            <div className="gig-stats-grid">
                <div className="gig-stat-item">
                    <div className="gig-stat-value total">
                        {isLoading ? "-" : totalGigs}
                    </div>
                    <div className="gig-stat-label">Total Gigs</div>
                </div>
                <div className="gig-stat-item">
                    <div className="gig-stat-value sent">
                        {isLoading ? "-" : sentUpcoming}
                    </div>
                    <div className="gig-stat-label">Sent / Upcoming</div>
                </div>
                <div className="gig-stat-item">
                    <div className="gig-stat-value completed">
                        {isLoading ? "-" : completed}
                    </div>
                    <div className="gig-stat-label">Completed</div>
                </div>
            </div>
        </div>
    );
};

export default GigStatsCard;
